import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const StyledStatus = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isHovered",
})<{ isHovered?: boolean }>(({ isHovered }) => ({
  opacity: isHovered ? 1 : 0,
  cursor: "pointer",
  marginLeft: "1rem",
  display: "flex",
}));
